import {
  Accordion as ChakraAccordion,
  AccordionItem as ChakraAccordionItem,
  AccordionButton as ChakraAccordionButton,
  AccordionPanel as ChakraAccordionPanel,
  AccordionIcon as ChakraAccordionIcon,
} from "@chakra-ui/react";

export function Accordion({
  children,
  defaultIndex,
  allowMultiple,
  ...props
}: {
  children: React.ReactNode;
  defaultIndex?: number | number[];
  allowMultiple?: boolean;
}) {
  return (
    <ChakraAccordion defaultIndex={defaultIndex} allowMultiple={allowMultiple} {...props}>
      {children}
    </ChakraAccordion>
  );
}

Accordion.Item = function AccordionItem({ children }: { children: React.ReactNode }) {
  return <ChakraAccordionItem border="none">{children}</ChakraAccordionItem>;
};
Accordion.ItemTrigger = function AccordionItemTrigger({ children }: { children: React.ReactNode }) {
  return (
    <ChakraAccordionButton border="none" _hover={{ backgroundColor: "transparent" }}>
      {children}
    </ChakraAccordionButton>
  );
};
Accordion.ItemIndicator = ChakraAccordionIcon;
Accordion.ItemContent = function AccordionItemContent({ children }: { children: React.ReactNode }) {
  return (
    <ChakraAccordionPanel backgroundColor="grey.150" padding="1rem">
      {children}
    </ChakraAccordionPanel>
  );
};
